//React
import React, { useState, useEffect, useReducer } from 'react';
import { useNavigate } from "react-router-dom";

//React Redux
import { useDispatch, useSelector } from 'react-redux';

//
import { getData, updateAppState } from "../../actions/appstate";
import { useProductVariant } from "../../hooks/use-product-variant";

//MUI
import {
    Grid, Button, LinearProgress, Badge, Modal,
    Table, TableBody, TableCell, TableContainer,
    FormControl, Select, InputLabel, MenuItem,
    TableHead, TableRow, Typography, Switch, Tooltip, Radio
} from '@mui/material';
import {
    CloseSharp as CloseSharpIcon,
    ArrowBackIosNewSharp as ArrowBackIosNewSharpIcon,
    ArrowForwardIosSharp as ArrowForwardIosSharpIcon,
    CheckSharp as CheckSharpIcon,
    GridOn as GridOnIcon
}
    from '@mui/icons-material';
import DownloadIcon from '@mui/icons-material/Download';
import BarChartIcon from '@mui/icons-material/BarChart';

import { border, Box, fontSize, textAlign } from '@mui/system';

//Moments
import moment from 'moment';

//APP's
import theme from '../../theme';
import './dailyflash.css'
import DataTable from './DataTable';
import DataChart from './DataChart';
import { styled } from "@mui/material/styles";
import MonthCard from './MonthCard';
import {
    calculateMonthlyData, getMonthlyData, processMonthlyMarketData,
    processMonthlyPropertyData, getTotalRowData, getMonthlyBudgetData
} from './functions';
import dataService from '../../services/data.service';
import { getTileById, getSeriesById, deepCopy, getDayDateKey, setLodgiqCookie, getLodgiqCookie } from '../../app/util';
import TableToExcel from "@linways/table-to-excel";
import { CustomSVGIcon } from '../layout/dashboard-ui';
import DayDateToggle from '../Workspace/subComponents/leftComponents/DayDateToggle';
import { APP_CACHE } from '../../app/config';
import { UPDATE_STATE } from '../../actions/types';
import { analytics } from '../../hooks/use-analytics';


function DailyFlash(props) {
    const { app_state, ui_state } = useSelector(
        (state) => state.app.current_state
    );
    const dispatch = useDispatch();
    const { auth } = useSelector(state => state);
    const { user, profile } = auth;
    const { dayDate } = app_state.workspace_controls;
    let sdlyText = getDayDateKey(dayDate, 'sdly').toUpperCase();
    const [compState, setCompState] = useState({ dataStatus: { all: 'idle' } });
    const [chartDisplay, setChartDisplay] = useState(ui_state.flash_chartView);
    // const [dataView, setDataView] = useState("rolling12");
    let viewMode = (ui_state.data_view_mode === "Current Year") ? "currYear" : "rolling12";
    const [dataView, setDataView] = useState(viewMode);
    const [reportData, setReportData] = useState(null);
    const [budgetData, setBudgetData] = useState(null);
    const [totalRowData, setTotalRowData] = useState({});

    const [forecastData, setForecastData] = useState(null);
    const [showOnLogin, setShowOnLogin] = useState((ui_state.flash_showOnLogin !== null) ? ui_state.flash_showOnLogin : auth.user.flash_report);
    // const [showOnLogin, setShowOnLogin] = useState(auth.user.flash_report);
    const { hasFeature } = useProductVariant();
    const selected_property = profile.property_details.find(property => property.id == app_state.property_id)
    const { product_variant } = selected_property;
    let selectedPropertyName = selected_property.name;
    let initialSelectedID = selected_property.id;

    const [sdlyAsOf, setSdlyAsof] = useState(moment(app_state.as_of_date).subtract(1, "year").format("YYYY-MM-DD"));

    const PROPERTY_AND_MARKET = 'property and market';
    const PROPERTY = 'property';
    const MARKET = 'market';
    let dataFor = PROPERTY_AND_MARKET;
    if (hasFeature(["daily_flash", "daily_flash_mark"], 'tiles')) {
        initialSelectedID = selected_property.id
        dataFor = PROPERTY_AND_MARKET;
    } else if (hasFeature(["daily_flash"], 'tiles')) {
        initialSelectedID = selected_property.id
        dataFor = PROPERTY;
    } else if (hasFeature(["daily_flash_mark"], 'tiles') && app_state.market_settings.length > 0) {
        initialSelectedID = app_state.market_settings[0].market_id
        dataFor = MARKET;
    }

    const [selectedMarketProperty, setSelectedMarketProperty] = useState(initialSelectedID)
    const [availableMarkets, setAvailableMarkets] = useState([]);

    const [isCollapse, setIsCollapse] = useState(ui_state.flash_collapse);
    const toggleCollapse = () => {
        let flash_collapse = true;

        if (isCollapse) {
            setIsCollapse(false);
            flash_collapse = false;
        } else {
            setIsCollapse(true);
            flash_collapse = true;
        }
        dispatch({
            type: 'UPDATE_STATE',
            payload: {
                ui_state: {
                    flash_collapse: flash_collapse,
                }
            }
        });
    }

    const handleChartShow = () => {
        setChartDisplay(state => !state);
        dispatch({
            type: 'UPDATE_STATE',
            payload: {
                ui_state: {
                    flash_chartView: !chartDisplay,
                }
            }
        });
    }

    const handleDownloadReport = () => {
        if (reportData && reportData.length > 0) {
            let resource = selectedPropertyName;
            if (availableMarkets.length > 1) {
                resource = availableMarkets.find(i => i.id === selectedMarketProperty);
            }
            let exportFileName = moment(app_state.as_of_date).format('MMM DD YYYY') + "_" + resource.label + "_DailyFlash";
            TableToExcel.convert(document.getElementById("dailyFlashTable"), {
                name: exportFileName + ".xlsx",
                sheet: {
                    name: "Daily Flash Report"
                }
            });
        }

    }

    const { data_sources } = getTileById('daily_flash');
    let apc = APP_CACHE;
    useEffect(() => {

        // setShowOnLogin((ui_state.flash_showOnLogin !== null) ? ui_state.flash_showOnLogin : auth.user.flash_report);
        let rangeFromDate = new moment(app_state.as_of_date).startOf('month').format('YYYY-MM-DD');
        let rangeUntilDate = new moment(rangeFromDate).add(1, "year").endOf('month').format('YYYY-MM-DD');

        const availableMarkets = [];

        switch (dataFor) {
            case PROPERTY_AND_MARKET:
                availableMarkets.push({ id: selected_property.id, type: "property", "label": selected_property.name });
                app_state.market_settings.forEach(market => {
                    availableMarkets.push({ id: market.market_id, type: "market", "label": market.label });
                })
                break;
            case PROPERTY:
                availableMarkets.push({ id: selected_property.id, type: "property", "label": selected_property.name });
                break;
            case MARKET:
                app_state.market_settings.forEach(market => {
                    availableMarkets.push({ id: market.market_id, type: "market", "label": market.label });
                })
                break;
            default:
                availableMarkets = [];
                break;
        }
        setAvailableMarkets(availableMarkets)
        if (dataFor === PROPERTY_AND_MARKET || dataFor === PROPERTY) {
            const mainPromises = [];
            let pickupAsOf = moment(app_state.as_of_date).subtract(1, "days").format("YYYY-MM-DD");
            const ignoreAPI = ['OSRYear', 'OSRContrainedForecastYear'];
            const payLoads = {

                BudgetYear: {
                    "method": "GET",
                    "property_id": app_state.property_id,
                    "fromDate": moment(app_state.as_of_date).startOf('month').format('YYYY-MM-DD'),
                    "toDate": moment(app_state.as_of_date).add(3, 'Month').endOf('month').format('YYYY-MM-DD'),
                },

            };
            let summaryDataView = ""
            let primary_stay_range = {};
            console.log("called summary ");
            if (dataView === "currYear") {
                summaryDataView = "currYear";
                primary_stay_range = {
                    date_from: moment().startOf('year').format("YYYY-MM-DD"),
                    date_until: moment().endOf('year').format("YYYY-MM-DD"),
                };
            }
            let summaryApiType = (dataView == "currYear") ? "Range" : "";
            const hotelSummaryAPI = getData({
                ...app_state,

                property_id: app_state.property_id,
                as_of_date: app_state.as_of_date,
                primary_stay_range,
                summaryDataView,
                active_api: "HotelSummary" + summaryApiType,
            })();
            // const hotelSummaryAPI = getData({
            //     ...app_state,

            //     property_id: app_state.property_id,
            //     as_of_date: app_state.as_of_date,
            //     active_api: "HotelSummary",
            // })();
            mainPromises.push(hotelSummaryAPI);
            const hotelSummaryPickupAPI = getData({
                ...app_state,
                property_id: app_state.property_id,
                as_of_date: pickupAsOf,
                primary_stay_range,
                summaryDataView,
                active_api: "HotelSummaryPickup" + summaryApiType,
            })();
            // const hotelSummaryPickupAPI = getData({
            //     ...app_state,
            //     property_id: app_state.property_id,
            //     as_of_date: pickupAsOf,
            //     active_api: "HotelSummaryPickup",
            // })();
            mainPromises.push(hotelSummaryPickupAPI);
            data_sources.map(activeApi => {
                let new_data_status = {};
                let payload = payLoads[activeApi];
                // dataService.updateDataCache(activeApi, { payload: payload });
                let dataSeries = getSeriesById(activeApi);

                //if (setCompState[activeApi] !== 'loadings') {
                new_data_status[activeApi] = 'loading';
                if (!ignoreAPI.includes(activeApi)) {

                    let apiCallStarting = getData({
                        ...app_state, active_api: activeApi,
                    })();
                    mainPromises.push(apiCallStarting);
                    apiCallStarting.then(
                        (rs) => {
                            new_data_status[activeApi] = 'loaded';
                            setCompState({ ...compState, dataStatus: { ...new_data_status } });
                        },
                        (erro) => {
                            new_data_status[activeApi] = 'loaded';
                            setCompState({ ...compState, dataStatus: { ...new_data_status } });
                        }
                    )

                    setCompState({ ...compState, dataStatus: { ...new_data_status } });

                }
                //}
            });

            Promise.allSettled(mainPromises).then(
                (settled) => {
                    let propertySummary = null, propertyPickupSummary = null;
                    console.log(settled);
                    settled.forEach((item, index) => {
                        if (item.status === "fulfilled") {
                            if (index === 0 && item.value.status === "success") {
                                propertySummary = item.value.data;

                                setSdlyAsof(moment(item.value.meta.sdly_asof).format("YYYY-MM-DD"))
                            }
                            if (index === 1 && item.value.status === "success") {
                                propertyPickupSummary = item.value.data
                            }
                        }
                        else {
                            console.log("error");
                            // setResError(true);
                        }
                    })
                    const reportData = processMonthlyPropertyData(propertySummary, propertyPickupSummary, ui_state.currency_symbol, dayDate);
                    const totalRowData = getTotalRowData(propertySummary, propertyPickupSummary, ui_state.currency_symbol, "hotel")
                    setTotalRowData(totalRowData);
                    console.log(auth);
                    setReportData(reportData)
                    let forecastMonthlyData = reportData.slice(0, 3).map((item, index) => {
                        return item.forecast;
                    })

                    setForecastData(forecastMonthlyData);
                    // Budget Data
                    let budgetMonthlyData = settled[2].value; //settled[2].value;
                    // calculating budget data as per the month wise 
                    let budgetCalData = (budgetMonthlyData) ? getMonthlyBudgetData(budgetMonthlyData, app_state, ui_state) : null;
                    setBudgetData(budgetCalData);

                })

        }

        return () => {
            //clearInterval(intervalId);
            let count = getLodgiqCookie("loginCount");
            if (!profile.tours_not_show_again && JSON.parse(count) === 1) {
                setTimeout(() => {
                    // analytics.track("announcement_popup_open", {});
                    dispatch({
                        type: UPDATE_STATE,
                        payload: {
                            ui_state: {
                                show_announcement_popup: true
                            },
                        }
                    });
                }, 5000);
            }
        }
    }, [])

    useEffect(() => {
        let resource = availableMarkets.find(i => i.id === selectedMarketProperty);
        if (resource && resource.type && resource.type !== "market") {
            // let otbMonthlyData = getMonthlyData(otbData, ui_state, app_state);
            // setReportData(otbMonthlyData);
            getMarketData(selectedMarketProperty, dataView);
        }
        if (resource && resource.type && resource.type === "market") {
            getMarketData(selectedMarketProperty, dataView);

        }

    }, [app_state.workspace_controls.dayDate])

    useEffect(() => {
        if (availableMarkets.length > 0 && availableMarkets[0].type === "market") {
            let event = {
                target: {
                    value: availableMarkets[0].id,
                }
            }
            handlePropertyMarketChange(event);
        }
    }, [availableMarkets])

    const loadData = (type) => {

    }
    const handleChange = (type, value) => {
        setShowOnLogin(value);
        let formData = new FormData();
        formData.append('flashReport', value);
        const showOnLoginPayload = {
            "flashReport": value,
        }
        dataService.getData({ api: "users/edit-user/", request: { method: 'PUT', formData } })
            .then((res) => {
                dispatch(updateAppState("show_flash_report_on_login", {
                    app_state: {
                        ...app_state
                    },
                    ui_state: { ...ui_state, flash_showOnLogin: value }
                }));
            })
    }
    const [resError, setResError] = useState(false);
    const getMarketData = (selectedMarketProperty, dataView) => {
        // dataService.updateDataCache("MarketSummary", {});
        let resource = availableMarkets.find(i => i.id === selectedMarketProperty);
        const mainPromises = [];
        let pickupAsOf = moment(app_state.as_of_date).subtract(1, "days").format("YYYY-MM-DD");
        let summaryDataView = ""
        let primary_stay_range = {};

        if (dataView === "currYear") {
            summaryDataView = "currYear";
            primary_stay_range = {
                date_from: moment().startOf('year').format("YYYY-MM-DD"),
                date_until: moment().endOf('year').format("YYYY-MM-DD"),
            };
        }
        let summaryApiType = (dataView == "currYear") ? "Range" : "";
        if (resource.type === "market") {
            const market = app_state.market_settings.find(i => i.market_id === resource.id);
            if (market) {
                const marketSummaryAPI = getData({
                    ...app_state,
                    selected_market: market,
                    as_of_date: app_state.as_of_date,
                    primary_stay_range,
                    summaryDataView,
                    active_api: "MarketSummary" + summaryApiType,
                })();
                //console.log("sonuuuuuuuuuuuuuuuu", marketSummaryAPI)
                mainPromises.push(marketSummaryAPI);

                const marketSummaryPickupAPI = getData({
                    ...app_state,
                    selected_market: market,
                    as_of_date: pickupAsOf,
                    primary_stay_range,
                    summaryDataView,
                    active_api: "MarketSummaryPickup" + summaryApiType,
                })();
                mainPromises.push(marketSummaryPickupAPI);
                Promise.allSettled(mainPromises).then(
                    (settled) => {
                        let marketSummary = null, marketSummaryPickup = null;
                        settled.forEach(i => {

                            if (i.status === "fulfilled") {
                                if (i.value.data_id === ("MarketSummary" + summaryApiType) && i.value.status === "success") {
                                    marketSummary = i.value.data;
                                    setSdlyAsof(moment(i.value.meta.sdly_asof).format("YYYY-MM-DD"))
                                }
                                if (i.value.data_id === ("MarketSummaryPickup" + summaryApiType) && i.value.status === "success") {
                                    marketSummaryPickup = i.value.data
                                }
                            }
                            else {
                                console.log("errorrrrrrrrrrrrrrr");
                                // setResError(true);
                            }

                        })
                        const reportData = processMonthlyMarketData(marketSummary, marketSummaryPickup, ui_state.currency_symbol, dayDate);
                        const totalRowData = getTotalRowData(marketSummary, marketSummaryPickup, ui_state.currency_symbol, "market")
                        setTotalRowData(totalRowData);
                        setReportData(prev => {
                            return reportData;
                        })
                        let forecastMonthlyData = getForecastMonthData(dataView, reportData);

                        setForecastData(forecastMonthlyData);
                        setResError(false);

                    }).catch(e => {
                        console.log(e);
                        setResError(true);
                    })
            }

        } else {
            setResError(false);

            const hotelSummaryAPI = getData({
                ...app_state,
                property_id: app_state.property_id,
                as_of_date: app_state.as_of_date,
                primary_stay_range,
                summaryDataView,
                active_api: "HotelSummary" + summaryApiType,
            })();
            mainPromises.push(hotelSummaryAPI);
            const hotelSummaryPickupAPI = getData({
                ...app_state,
                property_id: app_state.property_id,
                as_of_date: pickupAsOf,
                primary_stay_range,
                summaryDataView,
                active_api: "HotelSummaryPickup" + summaryApiType,
            })();
            mainPromises.push(hotelSummaryPickupAPI);
            Promise.allSettled(mainPromises).then(
                (settled) => {
                    let propertySummary = null, propertyPickupSummary = null;
                    console.log(settled);
                    settled.forEach((item, index) => {

                        if (item.status === "fulfilled") {
                            if (index === 0 && item.value.status === "success") {
                                propertySummary = item.value.data;
                                setSdlyAsof(moment(item.value.meta.sdly_asof).format("YYYY-MM-DD"))
                            }
                            if (index === 1 && item.value.status === "success") {
                                propertyPickupSummary = item.value.data
                            }
                        }
                        else {
                            console.log("error");
                            // setResError(true);
                        }

                    })
                    const reportData = processMonthlyPropertyData(propertySummary, propertyPickupSummary, ui_state.currency_symbol, dayDate);
                    const totalRowData = getTotalRowData(propertySummary, propertyPickupSummary, ui_state.currency_symbol, "hotel")
                    setTotalRowData(totalRowData);
                    setReportData(prev => {
                        return reportData;
                    })
                    let forecastMonthlyData = getForecastMonthData(dataView, reportData);

                    setForecastData(forecastMonthlyData);
                    setResError(false);

                }).catch(e => {
                    console.log(e);
                    setResError(true);
                })

        }

    }
    const getForecastMonthData = (dataView, reportData) => {
        let forecastMonthlyData = [];
        let currentMonth = parseInt(moment(app_state.as_of_date).format("MM"));
        reportData.forEach((item, index) => {
            if (dataView === "rolling12") {
                if (index >= 0 && index < 3) {

                    forecastMonthlyData.push(item.forecast)
                }
            } else {
                let monthNumb = parseInt(moment(item.monthData).format("MM"));
                console.log("reportDataItem", monthNumb, currentMonth);
                if (currentMonth >= 10) {
                    if (index >= 9 && index < 12) {
                        forecastMonthlyData.push(item.forecast)
                    }
                } else if (monthNumb >= currentMonth && monthNumb < currentMonth + 3) {
                    forecastMonthlyData.push(item.forecast)
                }
            }
        })
        return forecastMonthlyData;

    }
    const changeDataView = (value) => {
        let dataView = value
        setReportData(null);
        setForecastData(null);
        setDataView(dataView);
        setResError(false);
        getMarketData(selectedMarketProperty, dataView);

        // Below line is because api sending these type of values.
        let view_mode = (value === "currYear") ? "Current Year" : "Rolling 12 Months";
        dispatch({
            type: 'UPDATE_STATE',
            payload: {
                ui_state: {
                    data_view_mode: view_mode,
                }
            }
        });



        // let mainPromises=[];
        // let summaryDataView=""
        // let primary_stay_range={};
        // if(dataView === "currYear"){
        //     summaryDataView="currYear";
        //     primary_stay_range={
        //         date_from:moment().startOf('year').format("YYYY-MM-DD"),
        //         date_until:moment().endOf('year').format("YYYY-MM-DD"),
        //     };
        // }

        // let pickupAsOf = moment(app_state.as_of_date).subtract(1, "days").format("YYYY-MM-DD");
        // let resource = availableMarkets.find(i => i.id === selectedMarketProperty);
        // if(resource.type !== "market"){
        //     const hotelSummaryAPI = getData({
        //         ...app_state,
        //         property_id: app_state.property_id,
        //         primary_stay_range,
        //         summaryDataView,
        //         as_of_date: app_state.as_of_date,
        //         active_api: "HotelSummaryRange",
        //     })();

        //     mainPromises.push(hotelSummaryAPI);
        //     const hotelSummaryPickupAPI = getData({
        //         ...app_state,
        //         primary_stay_range,
        //         summaryDataView,
        //         property_id: app_state.property_id,
        //         as_of_date: pickupAsOf,
        //         active_api: "HotelSummaryPickupRange",
        //     })();
        //     mainPromises.push(hotelSummaryPickupAPI);
        //     Promise.allSettled(mainPromises).then(
        //         (settled) => {
        //             let propertySummary = null, propertyPickupSummary = null;
        //             console.log(settled);
        //             settled.forEach((item, index) => {

        //                 if (item.status === "fulfilled") {
        //                     if (index === 0 && item.value.status === "success") {
        //                         propertySummary = item.value.data;
        //                     }
        //                     if (index === 1 && item.value.status === "success") {
        //                         propertyPickupSummary = item.value.data
        //                     }
        //                 }
        //                 else {
        //                     console.log("error");
        //                     // setResError(true);
        //                 }

        //             })
        //             const reportData = processMonthlyPropertyData(propertySummary, propertyPickupSummary, ui_state.currency_symbol, dayDate);
        //             const totalRowData = getTotalRowData(propertySummary,propertyPickupSummary, ui_state.currency_symbol, "hotel")
        //             setTotalRowData(totalRowData)
        //             setReportData(prev => {
        //                 return reportData;
        //             })
        //             let forecastMonthlyData =getForecastMonthData(dataView,reportData);

        //             setForecastData(forecastMonthlyData);
        //             setResError(false);

        //     }).catch(e => {
        //             console.log(e);
        //             setResError(true);
        //     })
        // } else {
        //     const marketSummaryAPI = getData({
        //         ...app_state,
        //         property_id: app_state.property_id,
        //         primary_stay_range,
        //         summaryDataView,
        //         as_of_date: app_state.as_of_date,
        //         active_api: "MarketSummaryDailyFlash",
        //     })();

        //     mainPromises.push(marketSummaryAPI);
        //     const marketSummaryPickupAPI = getData({
        //         ...app_state,
        //         primary_stay_range,
        //         summaryDataView,
        //         property_id: app_state.property_id,
        //         as_of_date: pickupAsOf,
        //         active_api: "MarketSummaryPickup",
        //     })();
        //     mainPromises.push(marketSummaryPickupAPI);
        //     Promise.allSettled(mainPromises).then(
        //         (settled) => {
        //             let marketSummary = null, marketPickupSummary = null;
        //             console.log(settled);
        //             settled.forEach((item, index) => {

        //                 if (item.status === "fulfilled") {
        //                     if (index === 0 && item.value.status === "success") {
        //                         marketSummary = item.value.data;
        //                     }
        //                     if (index === 1 && item.value.status === "success") {
        //                         marketPickupSummary = item.value.data
        //                     }
        //                 }
        //                 else {
        //                     console.log("error");
        //                     // setResError(true);
        //                 }

        //             })
        //             const reportData = processMonthlyMarketData(marketSummary, marketPickupSummary, ui_state.currency_symbol, dayDate);
        //             const totalRowData = getTotalRowData(marketSummary,marketPickupSummary, ui_state.currency_symbol, "market")
        //             setTotalRowData(totalRowData)
        //             setReportData(prev => {
        //                 return reportData;
        //             })
        //             let forecastMonthlyData =getForecastMonthData(dataView,reportData);

        //             setForecastData(forecastMonthlyData);
        //             setResError(false);

        //     }).catch(e => {
        //             console.log(e);
        //             setResError(true);
        //     })
        // }

    }
    const handlePropertyMarketChange = (e) => {
        let selectedMarketProperty = e.target.value;
        setReportData(null);
        setForecastData(null);
        setSelectedMarketProperty(selectedMarketProperty);
        getMarketData(selectedMarketProperty, dataView);

    }
    const propertyMarketSelect = (<FormControl >

        <Select
            className='daily-flash-property-select'
            labelId="property-market-select-label"
            id="property-market-select"
            value={selectedMarketProperty}
            label=""
            onChange={handlePropertyMarketChange}
        >
            {availableMarkets.map((market, index) => {
                return (<MenuItem value={market.id} key={index}>{market.label}</MenuItem>)
            })}


        </Select>
    </FormControl>)
    return (
        <div>


            <Box
                className="daily-flash-wrap"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '83vw',
                    width: '83vw', height: 'auto', minHeight: '95vh !important',
                    overflow: "visible !important"
                    // bgcolor: '#333',
                    // boxShadow: 10, borderRadius: '5px'
                }}>


                <div className="pop-up-header clearfix request-popup-header" style={{ padding: "2px 12px" }}>
                    <Box sx={{ padding: "4px 0px", float: 'left', position: 'relative', width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", fontFamily: "SFUI Medium" }}>
                        <Button sx={{
                            minWidth: 'auto', width: '22px', height: '22px', p: '7px', position: 'absolute', top: -12, right: -20, zIndex: 1,
                            borderRadius: '50%', background: '#000', color: '#FFF', fontSize: '10px', border: '1px solid #EBEBEB', '&:hover': { background: '#000' }
                        }} onClick={props.handleClose}>
                            <CloseSharpIcon fontSize='small' />
                        </Button>

                        <div className="tile-title" data-tile-icon="icon-icon-events" data-id="events" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {/* <span className="icon icon-custom daily-flash">
                                <img src="/assets/img/business-intelligence.svg" width="22" height="22" />
                            </span> */}

                            <div className='report-details'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 13 14" fill="none">
                                    <path d="M4.00054 7.00067V6.00098C4.00054 5.86832 4.05324 5.74109 4.14704 5.64729C4.24085 5.55348 4.36808 5.50078 4.50074 5.50078C4.6334 5.50078 4.76063 5.55348 4.85443 5.64729C4.94824 5.74109 5.00094 5.86832 5.00094 6.00098V7.00139C5.00094 7.13405 4.94824 7.26128 4.85443 7.35508C4.76063 7.44889 4.6334 7.50159 4.50074 7.50159C4.36808 7.50159 4.24085 7.44889 4.14704 7.35508C4.05324 7.26128 4.00054 7.13333 4.00054 7.00067ZM6.50119 7.50123C6.63375 7.50123 6.76089 7.44857 6.85463 7.35483C6.94837 7.26109 7.00103 7.13395 7.00103 7.00139V5.50042C7.00103 5.36776 6.94833 5.24053 6.85452 5.14672C6.76071 5.05292 6.63349 5.00022 6.50082 5.00022C6.36816 5.00022 6.24093 5.05292 6.14713 5.14672C6.05332 5.24053 6.00062 5.36776 6.00062 5.50042V7.00067C6.00053 7.06643 6.01341 7.13156 6.03853 7.19234C6.06365 7.25311 6.10052 7.30833 6.14702 7.35483C6.19352 7.40133 6.24874 7.4382 6.30952 7.46332C6.37029 7.48844 6.43542 7.50132 6.50119 7.50123ZM8.50127 7.50123C8.63384 7.50123 8.76097 7.44857 8.85471 7.35483C8.94845 7.26109 9.00111 7.13395 9.00111 7.00139V5.00058C9.00111 4.86792 8.94841 4.74069 8.85461 4.64688C8.7608 4.55307 8.63357 4.50038 8.50091 4.50038C8.36825 4.50038 8.24102 4.55307 8.14721 4.64688C8.05341 4.74069 8.00071 4.86792 8.00071 5.00058V7.00067C8.00061 7.06643 8.0135 7.13156 8.03862 7.19234C8.06374 7.25311 8.10061 7.30833 8.14711 7.35483C8.19361 7.40133 8.24883 7.4382 8.3096 7.46332C8.37038 7.48844 8.43551 7.50132 8.50127 7.50123ZM12.0016 3.00049V9.00148H12.5014C12.6341 9.00148 12.7613 9.05418 12.8551 9.14798C12.949 9.24179 13.0016 9.36901 13.0016 9.50168C13.0016 9.63434 12.949 9.76157 12.8551 9.85537C12.7613 9.94918 12.6341 10.0019 12.5014 10.0019H7.00103V11.0854C7.33467 11.2033 7.61586 11.4355 7.7949 11.7407C7.97394 12.046 8.03931 12.4047 7.97945 12.7535C7.9196 13.1023 7.73836 13.4187 7.46779 13.6468C7.19721 13.8749 6.85472 14 6.50082 14C6.14693 14 5.80444 13.8749 5.53386 13.6468C5.26329 13.4187 5.08205 13.1023 5.0222 12.7535C4.96234 12.4047 5.02771 12.046 5.20675 11.7407C5.38579 11.4355 5.66698 11.2033 6.00062 11.0854V10.0019H0.500202C0.36754 10.0019 0.240311 9.94918 0.146505 9.85537C0.0526989 9.76157 0 9.63434 0 9.50168C0 9.36901 0.0526989 9.24179 0.146505 9.14798C0.240311 9.05418 0.36754 9.00148 0.500202 9.00148H1.00004V3.00049C0.734845 3.0003 0.480574 2.89482 0.293118 2.70722C0.105662 2.51963 0.000360889 2.26529 0.000360959 2.00009V1.0004C0.000360959 0.73508 0.10576 0.480625 0.293373 0.293013C0.480985 0.105401 0.735442 0 1.00077 0H12.0016C12.2669 0 12.5214 0.105401 12.709 0.293013C12.8966 0.480625 13.002 0.73508 13.002 1.0004V2.00081C13.0018 2.26601 12.8963 2.52028 12.7087 2.70773C12.5212 2.89519 12.2668 3.00049 12.0016 3.00049ZM7.00103 12.5018C7.00103 12.4029 6.97171 12.3063 6.91679 12.2241C6.86187 12.1419 6.7838 12.0778 6.69247 12.04C6.60113 12.0022 6.50063 11.9923 6.40367 12.0116C6.30671 12.0309 6.21765 12.0785 6.14774 12.1484C6.07784 12.2183 6.03024 12.3073 6.01095 12.4043C5.99166 12.5013 6.00156 12.6018 6.03939 12.6931C6.07722 12.7844 6.14129 12.8625 6.22349 12.9174C6.30569 12.9723 6.40233 13.0016 6.50119 13.0016C6.63375 13.0016 6.76089 12.949 6.85463 12.8552C6.94837 12.7615 7.00103 12.6344 7.00103 12.5018ZM1.00077 2.00009H12.0016V1.0004H1.00077V2.00009ZM11.0019 3.00049H2.00045V9.00148H11.0019V3.00049Z" fill="#F8F9FA" />
                                </svg>
                                <div className="tile-name">Daily Flash</div>
                            </div>

                            <div className='property-details'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_482_9640)">
                                        <path d="M13.127 11.375H12.252V5.24996C12.252 5.01789 12.1598 4.79533 11.9957 4.63124C11.8316 4.46715 11.6091 4.37496 11.377 4.37496H7.87701V1.74996C7.87712 1.59151 7.83419 1.436 7.75282 1.30004C7.67145 1.16408 7.55469 1.05277 7.415 0.977984C7.27531 0.903198 7.11794 0.867747 6.95967 0.875415C6.80141 0.883083 6.6482 0.933581 6.51639 1.02152L2.14139 3.93746C2.02137 4.01753 1.92302 4.12604 1.85508 4.25332C1.78715 4.38061 1.75174 4.52271 1.75201 4.66699V11.375H0.877014C0.760982 11.375 0.649702 11.4211 0.567655 11.5031C0.485608 11.5851 0.439514 11.6964 0.439514 11.8125C0.439514 11.9285 0.485608 12.0398 0.567655 12.1218C0.649702 12.2039 0.760982 12.25 0.877014 12.25H13.127C13.243 12.25 13.3543 12.2039 13.4364 12.1218C13.5184 12.0398 13.5645 11.9285 13.5645 11.8125C13.5645 11.6964 13.5184 11.5851 13.4364 11.5031C13.3543 11.4211 13.243 11.375 13.127 11.375ZM11.377 5.24996V11.375H7.87701V5.24996H11.377ZM2.62701 4.66699L7.00201 1.74996V11.375H2.62701V4.66699ZM6.12701 6.12496V6.99996C6.12701 7.11599 6.08092 7.22727 5.99887 7.30932C5.91683 7.39136 5.80555 7.43746 5.68951 7.43746C5.57348 7.43746 5.4622 7.39136 5.38016 7.30932C5.29811 7.22727 5.25201 7.11599 5.25201 6.99996V6.12496C5.25201 6.00893 5.29811 5.89765 5.38016 5.8156C5.4622 5.73355 5.57348 5.68746 5.68951 5.68746C5.80555 5.68746 5.91683 5.73355 5.99887 5.8156C6.08092 5.89765 6.12701 6.00893 6.12701 6.12496ZM4.37701 6.12496V6.99996C4.37701 7.11599 4.33092 7.22727 4.24887 7.30932C4.16683 7.39136 4.05555 7.43746 3.93951 7.43746C3.82348 7.43746 3.7122 7.39136 3.63016 7.30932C3.54811 7.22727 3.50201 7.11599 3.50201 6.99996V6.12496C3.50201 6.00893 3.54811 5.89765 3.63016 5.8156C3.7122 5.73355 3.82348 5.68746 3.93951 5.68746C4.05555 5.68746 4.16683 5.73355 4.24887 5.8156C4.33092 5.89765 4.37701 6.00893 4.37701 6.12496ZM4.37701 9.18746V10.0625C4.37701 10.1785 4.33092 10.2898 4.24887 10.3718C4.16683 10.4539 4.05555 10.5 3.93951 10.5C3.82348 10.5 3.7122 10.4539 3.63016 10.3718C3.54811 10.2898 3.50201 10.1785 3.50201 10.0625V9.18746C3.50201 9.07143 3.54811 8.96015 3.63016 8.8781C3.7122 8.79605 3.82348 8.74996 3.93951 8.74996C4.05555 8.74996 4.16683 8.79605 4.24887 8.8781C4.33092 8.96015 4.37701 9.07143 4.37701 9.18746ZM6.12701 9.18746V10.0625C6.12701 10.1785 6.08092 10.2898 5.99887 10.3718C5.91683 10.4539 5.80555 10.5 5.68951 10.5C5.57348 10.5 5.4622 10.4539 5.38016 10.3718C5.29811 10.2898 5.25201 10.1785 5.25201 10.0625V9.18746C5.25201 9.07143 5.29811 8.96015 5.38016 8.8781C5.4622 8.79605 5.57348 8.74996 5.68951 8.74996C5.80555 8.74996 5.91683 8.79605 5.99887 8.8781C6.08092 8.96015 6.12701 9.07143 6.12701 9.18746Z" fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_482_9640">
                                            <rect width="20" height="20" fill="white" transform="translate(0.00201416)" />
                                        </clipPath>
                                    </defs>
                                </svg>

                                {/* <span className='property-name'> {app_state.property_name}</span> */}
                                {propertyMarketSelect}
                            </div>

                        </div>
                        <div className="tile-title" data-tile-icon="icon-icon-events" data-id="events" style={{ position: "absolute", left: "46%" }}>

                        </div>

                        {/* LRV-880 (uncomment the below div) */}
                        <div className="tile-title" style={{ fontSize: "13px", color: "white", position: "absolute", right: "5%", }}>
                            <span className="showonLogin" style={{
                                fontSize: "13px", textTransform: "unset", marginRight: "10px",
                                borderRight: "1px solid white", padding: "2px"
                            }}>
                                <span style={{ "position": "relative", "top": "1px" }}>Show On Login</span>
                                <Switch color='white' checked={showOnLogin} onChange={() => {
                                    handleChange("showLogin", !showOnLogin)
                                }} />

                            </span>
                            <span className="data-view-radio">
                                <Radio
                                    checked={dataView === 'currYear'}
                                    onChange={() => {
                                        changeDataView('currYear');
                                    }}
                                    value="currYear" size="md"
                                    name="radio-buttons"
                                    slotProps={{ input: { 'aria-label': 'Current Year' } }}
                                />
                                <span className={"inner-radio-label " + (dataView === 'currYear' && 'active')} onClick={() => {
                                    changeDataView('currYear');
                                }} style={{ paddingRight: "9px" }}>Current Year</span>
                                <Radio
                                    checked={dataView === 'rolling12'}
                                    onChange={() => {
                                        changeDataView('rolling12');
                                    }} size="md"
                                    value="rolling12"
                                    name="radio-buttons"
                                    slotProps={{ input: { 'aria-label': 'Rolling 12 months' } }}
                                />
                                <span className={"inner-radio-label " + (dataView === 'rolling12' && 'active')} onClick={() => {
                                    changeDataView('rolling12');
                                }}>Rolling 12 Months </span>

                            </span>
                        </div>
                        <Box>
                            <Button sx={{
                                minWidth: 'auto', p: '4px', mr: '4px', borderRadius: "50px",
                                color: '#9ed00d', '&:hover': { background: '#606060' }
                            }} onClick={handleChartShow} >
                                {chartDisplay && <Tooltip title="Table View" arrow followCursor><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z"></path></svg></Tooltip>}
                                {!chartDisplay && <Tooltip title="Chart View" arrow followCursor><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"></path></svg></Tooltip>}
                            </Button>
                            <Button sx={{
                                minWidth: 'auto', p: '4px', mr: "4px", borderRadius: "50px",
                                color: '#9ed00d', '&:hover': { background: '#606060' }
                            }} onClick={handleDownloadReport}>
                                <Tooltip title="Download Report" arrow followCursor><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z"></path></svg></Tooltip>
                            </Button>
                            {/* <Button sx={{
                                minWidth: 'auto', width: '22px', height: '22px', p: '7px',
                                mr: '7px', borderRadius: '50%', background: '#000', color: '#FFF', fontSize: '10px'
                            }} onClick={props.handleClose}>
                                <CloseSharpIcon fontSize='small' />
                            </Button> */}
                        </Box>
                    </Box>
                </div>





                <Grid item xs={8.5}>
                    <Box sx={{
                        borderRadius: '0px 0px 8px 8px', height: 'auto', minHeight: '22%', width: '100%',
                        background: '#fff', position: "absolute",
                    }}>
                        <Box sx={{ m: 1.5, borderRadius: "8px" }}>

                            <Box className={isCollapse ? "collapse" : "expand"} sx={{ zIndex: 1 }}>
                                {(!chartDisplay) ?
                                    <DataTable data={reportData} sdlyAsOf={sdlyAsOf} totalRowData={totalRowData} resError={resError} sdlyText={sdlyText} />
                                    :
                                    <DataChart data={reportData} resError={resError} />
                                }
                            </Box>

                            <Box onClick={toggleCollapse} className={isCollapse ? "collapse" : "expand"}>
                                <div className='daily-flash-expand-collapse-icon'>
                                    {isCollapse ?
                                        <svg onClick={toggleCollapse} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#606060" viewBox="0 0 256 256"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"></path></svg>
                                        :
                                        <svg onClick={toggleCollapse} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#606060" viewBox="0 0 256 256"><path d="M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z"></path></svg>
                                    }

                                </div>
                                <MonthCard
                                    data={reportData}
                                    forecastData={forecastData}
                                    budgetData={budgetData}
                                    selectedMarketProperty={selectedMarketProperty}
                                    availableMarkets={availableMarkets}
                                    resError={resError}
                                    sdlyText={sdlyText}
                                    dayDate={dayDate}
                                    dataView={dataView}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Box>

        </div>
    )
}

export default DailyFlash